/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { useTheme } from '../../../../providers/theme';

export interface ITermsTextProps {
  termsTitle?: string[];
  termsLink?: string;
}

export const TermsText = (props: ITermsTextProps) => {
  const { termsLink, termsTitle } = props;
  const theme = useTheme();
  return (
    <p style={{ textAlign: 'center' }}>
      {termsTitle[0]}{' '}
      <a
        href={termsLink}
        target="_blank"
        style={{ color: theme?.colors?.primary }}
      >
        {termsTitle[1]}
      </a>
    </p>
  );
};

TermsText.defaultProps = {
  termsTitle: ['By clicking continue you agree to our', 'terms and condition'],
  termsLink: '/terms',
};
